import { PropsWithChildren } from 'react';

import { Card } from '@mui/material';

function SectionLayout({ children }: PropsWithChildren) {
  return <Card>{children}</Card>;
}

export default SectionLayout;
